import React, { useState } from 'react';
import { change } from 'redux-form';
import { faMinusCircle, faPlusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './assets/program-array-fields.module.scss';
import { FieldInput } from '../../../../../components/redux-form/fields/FieldInput';
import GeneralEnumService from '../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../components/redux-form/utils/dropdown-values';
import { FieldDropdown } from '../../../../../components/redux-form/fields/FieldDropdown';
import { SelectList } from 'react-widgets';

const RenderFieldArray = (props: any) => {
    const { fields } = props;

    if (fields.length === 0) {
        fields.push({});
    }

    return (
        <ul className={classNames(styles.ul, styles.targetWrap, styles.propsWrap)} style={{ paddingTop: 0 }}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    fields={array}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                />
            ))}
        </ul>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    isNotFirst: boolean;
};

const RenderSubFields: React.FunctionComponent<Props> = ({ member, index, fields, isLast, isNotFirst }) => {
    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
    const programPromptItems: SelectObject[] = getValFromEnum(GeneralEnum);

    const row = fields.get(index);

    const creditStyle = {
        display: 'none',
    };

    const isApplied: boolean = +row.status === 3;
    return (
        <li style={+row.status === 2 ? creditStyle : {}} className=" w-100 mb-1 " key={index}>
            <FieldInput
                name={`${member}.checked`}
                type="checkbox"
                value={row.prompt}
                checked={row.checked}
                wrapperConfig={{
                    label: row.title,
                    classes: {
                        inputWrapper: 'customCheckbox',
                    },
                }}
            />
        </li>
    );
};
export default RenderFieldArray;
